const ENDPOINT_BASE='/artworks/';

export const getArtworkUrl = (code) => {
    return ENDPOINT_BASE+code;
}

export const getArtworksUrl = () => {
    return ENDPOINT_BASE+'all';
}

export const getPublicArtworksUrl = () => {
    return ENDPOINT_BASE+'public';
}

export const getCreateArtworkUrl = () => {
    return ENDPOINT_BASE;
}

export const getDeleteArtworkUrl = (code) => {
    return ENDPOINT_BASE+code;
}

export const getArtworkVisibilityUrl = (code) => {
    return ENDPOINT_BASE+'visibility/'+code;
}

export const getTokenizeArtworkUrl = (code) => {
    return ENDPOINT_BASE+'tokenize/'+code;
}

export const getAddArtworkImageUrl = (code) => {
    return ENDPOINT_BASE+'images/'+code;
}

export const getAddArtworkDocumentUrl = (code) => {
    return ENDPOINT_BASE+'documents/'+code;
}

export const getArtworkImageUrl = (path) => {
    return process.env.REACT_APP_BASE_URL+path;
}

export const getArtworkDocumentUrl = (path) => {
    return process.env.REACT_APP_BASE_URL+path;
}